import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FirmSharedService {
  engagementLetters: any = [];
  headersData: any = [];
  footersData: any = [];
  public finalArray = [{
    "coverHeaderData": {},
    "contentHeaderData": {},
    "coverFooterData": {},
    "contentFooterData": {},
    "coverLetter": [],
    "Subject":{},
    "content": [],
    "signatures": [],
    "createdDate": 0,
    "engagementLetterName": "",
    "typeOfTemplate":"",
    "signatureSrc": "",
    "signHeader": "",
    "signatureDesignation": "",
    "signatureName": "",
    'isLetterEditedAfterSend': false,
    'contentBeforeEdit': []
  }]
}
